export * from './window.module';
export * from './window.service';
export * from './window-ref';
export { NbWindowConfig, NbWindowState, NB_WINDOW_CONFIG } from './window.options';
//# sourceMappingURL=index.js.map